import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Descriptions, Tag } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import ZoneTypeContext from "../../../../context/wms/zone-type/context";
import ZoneTypeContextProvider from "../../../../context/wms/zone-type/provider";
import Spin from "../../../general/antd/spin";
import PageDetails from "../../../general/details";

const Details = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { details, actions, loading } = useContext(ZoneTypeContext);

  useEffect(() => {
    id && actions.getDetails(Number(id));
  }, [id]);

  if (loading.includes("details")) {
    return <Spin />;
  }

  return (
    <PageDetails
      title={t("details")}
      subtitle={t("zone_type")}
      buttonName={`${t("update_zone_type")}`}
      onClick={() => window.location.assign(`/wms/zone-types/update/${id}`)}
      loading={loading.includes("details")}
      onRefresh={() => actions.getDetails(Number(id))}
    >
      <Descriptions
        bordered
        column={1}
        size="middle"
      >
        <Descriptions.Item label={t("id")}>{details?.id}</Descriptions.Item>
        {details?.translations?.name?.map((translation) => (
          <Descriptions.Item
            key={translation.lang}
            label={`${t("name")} (${translation.lang})`}
          >
            {translation.value || "-"}
          </Descriptions.Item>
        ))}
        <Descriptions.Item label={t("zones_count")}>
          {details?.zonesCount ?? "-"}
        </Descriptions.Item>
        <Descriptions.Item label={t("is_active")}>
          {details?.isActive ? (
            <Tag icon={<CheckCircleOutlined />} color="success">
              {t("active")}
            </Tag>
          ) : (
            <Tag icon={<CloseCircleOutlined />} color="default">
              {t("inactive")}
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={t("created_at")}>
          {details?.createdAt ? String(details.createdAt) : "-"}
        </Descriptions.Item>
        <Descriptions.Item label={t("created_by")}>
          {details?.createdBy
            ? `${details.createdBy.firstName} ${details.createdBy.lastName} (${details.createdBy.mobile})`
            : "-"}
        </Descriptions.Item>
        <Descriptions.Item label={t("updated_at")}>
          {details?.updatedAt ? String(details.updatedAt) : "-"}
        </Descriptions.Item>
        <Descriptions.Item label={t("updated_by")}>
          {details?.updatedBy
            ? `${details.updatedBy.firstName} ${details.updatedBy.lastName} (${details.updatedBy.mobile})`
            : "-"}
        </Descriptions.Item>
      </Descriptions>
    </PageDetails>
  );
};

const ZoneTypeDetails = () => {
  return (
    <ZoneTypeContextProvider>
      <Details />
    </ZoneTypeContextProvider>
  );
};

export default ZoneTypeDetails;
